import Divider from '@shared/components/Divider/Divider';
import cx from 'classnames';
import { isValidElement } from 'react';

import useNotifications from 'modules/Notifications/NotificationsProvider/useNotifications';
import { formatTimestamp } from 'utils/utils';

import NotificationIcon from './NotificationIcon';
import { Notification as NotificationType } from '../../NotificationsProvider/utils';

const Notification = ({ id, onClick, onRead, icon, variant, title, content, timestamp, isRead }: NotificationType) => {
  const { markAsRead } = useNotifications();

  const handleClick = () => {
    if (!isRead) {
      markAsRead(id);
      if (onRead) onRead();
    }

    onClick();
  };

  return (
    <>
      <div
        className={cx('flex w-full p-2 gap-3 border border-transparent rounded-2xl', {
          'hover:cursor-pointer hover:border-gray-10 hover:bg-white hover:shadow-sm': onClick,
        })}
        onClick={handleClick}
      >
        <NotificationIcon icon={icon} variant={variant} isRead={isRead} />
        <div className="flex flex-col gap-3 overflow-hidden">
          <div className="text-size-sm flex flex-col gap-1">
            {title && <div className={isValidElement(title) ? 'font-normal' : 'font-medium'}>{title}</div>}
            <div className={title ? 'text-gray-80' : 'text-black'}>{content}</div>
          </div>
          <span className="text-gray-60 text-size-xs">{formatTimestamp(timestamp)}</span>
        </div>
      </div>
      <Divider className="last:hidden shrink-0" verticalSpace="sm" />
    </>
  );
};

export default Notification;
